import { useCallback, useEffect, useRef } from "react";

export function useTimer(onComplete, duration) {
  const timeoutRef = useRef(null);
  const callbackRef = useRef(onComplete);

  // Keep callback ref updated
  useEffect(() => {
    callbackRef.current = onComplete;
  }, [onComplete]);

  const start = useCallback(() => {
    if (timeoutRef.current) {
      return;
    }

    // Start new timer
    timeoutRef.current = setTimeout(() => {
      callbackRef.current?.();
      timeoutRef.current = null;
    }, duration);
  }, [duration]);

  const clear = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const reset = useCallback(() => {
    clear();
    start();
  }, [clear, start]);

  return { start, clear, reset };
}

export default useTimer;
